export default __webpack_public_path__ + "static/media/ic_search.96001dc4.svg";